import { useEffect, useState } from "react";
import {
  getOpcExports,
  onOpcExportsChange,
  TOpcExportHandles
} from "services/opc-export-state";

/**
 * Subscribes to the tracked OPC schedule imports.
 *
 * The store lives outside React because the producer and the consumers are far
 * apart: the page starts an import, an ag-grid cell renderer draws its spinner,
 * and a watcher polls it to completion. Cell renderers are also destroyed and
 * recreated on every row-data refresh and on scroll virtualization, so the
 * in-flight state cannot live in the cell.
 */
export default function useTrackedOpcExports(): TOpcExportHandles {
  const [handles, setHandles] = useState<TOpcExportHandles>(getOpcExports);

  useEffect(() => onOpcExportsChange(setHandles), []);

  return handles;
}
